module.exports = __webpack_public_path__ + "static/img/icon-alipay.49016f64.png";